module.exports = __webpack_public_path__ + "img/desktop-edge_web_li.96f9b938.webp";